import * as React from 'react';
import {Route, Switch} from 'react-router-dom';
import Ingreso from './pages/ingreso/ingreso';
import MainWrapper from '../theme/app/MainWrapper';
import Layout from './common/layout/layout';
import Portada from './pages/portada/portada';
import Liquidacion from './pages/liquidacion/liquidacion';
import Almacen from './pages/almacen/almacen';
import Mapa from './pages/mapa/mapa';
import Comprobantes from './pages/comprobantes/comprobantes';

const Router = () => (
    <MainWrapper>
        <main>
            <Switch>
                <Route component={wrappedRoutes}/>
            </Switch>
        </main>
    </MainWrapper>
);

const wrappedRoutes = () => (
    <div>
        <Ingreso/>
        <Layout/>
        <div className='container__wrap'>
            <Route path='/' component={Portada} exact={true}/>
            <Route path='/home' component={Portada} exact={true}/>
            <Route path='/liquidacion' component={Liquidacion} exact={true}/>
            <Route path='/almacen' component={Almacen} exact={true}/>
            <Route path='/ruta/:rutaId' component={Mapa} exact={true}/>
            <Route path='/comprobantes' component={Comprobantes} exact={true}/>
        </div>
    </div>
);

export default Router;



// WEBPACK FOOTER //
// ./src/components/router.tsx